import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import Ad from '@ifeng/ui_pc_ad';
import errorBoundary from '@ifeng/errorBoundary';
import { Event } from '@ifeng/ui_base';
import styles from './index.css';
import ColumnBox from './columnBox/';
import MapShowMode from '../mapShowMode.json';
import { handleAd } from '../../../../../../utils/handleAd';

const RightBar = errorBoundary(
    class extends PureComponent {
        static propTypes = {
            content: PropTypes.object,
            mode: PropTypes.string,
            current: PropTypes.number,
            adData: PropTypes.object,
        };

        state = {
            rdztData: this.props.content.initTab_right_rdzt || [],
        };

        event = new Event();

        // insertArr 为广告方想要插入的一组位置，replaceArr 为广告方想要替换的一组位置，adFn 为回调方法
        insert = (insertArr, replaceArr, adFn) => {
            if (adFn && typeof adFn === 'function') {
                const { rdztData } = this.state;
                const infoData = [...rdztData];
                const refs = [];

                // 广告插入，在指定位置后插入广告位数据
                insertArr.forEach(item => {
                    const ref = React.createRef();

                    refs.push({ index: item, ref });

                    infoData.splice(item, 0, { type: 'ad', ref });
                });

                // 广告替换，在指定位置删除原数据，替换为广告位数据
                replaceArr.forEach(item => {
                    const ref = React.createRef();

                    refs.push({ index: item, ref });

                    infoData.splice(item, 1, { type: 'ad', ref });
                });

                // 广告数据整合处理完毕后，更新列表数据
                this.setState(
                    {
                        rdztData: infoData,
                    },
                    () => {
                        const dom = {};

                        for (const ref of refs) {
                            dom[ref.index] = ref.ref.current;
                        }

                        adFn(dom);
                    },
                );
            }

            return;
        };

        async componentDidMount() {
            try {
                const {
                    adData: { ad_hotNews },
                } = this.props;

                const callback = await handleAd(ad_hotNews);

                // 将自定义广告插入方法传入，这样广告方即可调用
                callback(ad_hotNews.data, this.event, this.insert);
            } catch (e) {
                console.error(e);
            }

            try {
                this.adInit();
            } catch (e) {
                console.error(e);
            }
        }

        adInit = data => {
            try {
                // 触发广告位插入方法
                this.event.trigger('init', { data });
            } catch (e) {
                console.error(e);
            }
        };

        render() {
            const {
                content: { initTab_right_lqd, initTab_right_ycch, initTab_right_sc, initTab_right_jfb },
                mode,
                current,
                adData: { ad_rightRec_01 = {}, ad_rightRec_02 = {}, ad_rightRec_03 = {} },
            } = this.props;

            const { rdztData } = this.state;

            return (
                <div className={styles.box_right}>
                    {mode === 'more' ? (
                        <ColumnBox
                            title={MapShowMode[current].rightData.sc.title}
                            content={initTab_right_sc}
                            mode={MapShowMode[current].rightData.sc.mode}
                            type={MapShowMode[current].rightData.sc.type}
                            more={MapShowMode[current].rightData.sc.more || ''}
                        />
                    ) : null}
                    <ColumnBox title="撩球帝" content={initTab_right_lqd} mode="classicStream" />
                    <Ad content={ad_rightRec_01} styleName={styles.ad} />
                    <Chip
                        id="55039"
                        type="recommend"
                        title="tabs切换原创策划推荐位"
                        groupName="推荐位"
                        content={initTab_right_ycch}>
                        <ColumnBox title="原创策划" mode="bigPicFirst" />
                    </Chip>
                    <Ad content={ad_rightRec_02} styleName={styles.ad} />
                    {mode === 'more' ? (
                        <ColumnBox
                            title={MapShowMode[current].rightData.jfb.title}
                            content={initTab_right_jfb}
                            mode={MapShowMode[current].rightData.jfb.mode}
                            type={MapShowMode[current].rightData.jfb.type}
                            more={MapShowMode[current].rightData.jfb.more || ''}
                        />
                    ) : null}
                    <Chip
                        id="55040"
                        type="recommend"
                        title="tabs切换热点专题推荐位"
                        groupName="推荐位"
                        content={rdztData}>
                        <ColumnBox title="热点专题" mode="classicStream" />
                    </Chip>
                    <Ad content={ad_rightRec_03} styleName={styles.ad} />
                </div>
            );
        }
    },
);

export { RightBar };
export default RightBar;
